// import external dependencies
import 'jquery';
import Glide from '@glidejs/glide';
import Inputmask from "inputmask";

// Import everything from autoload


document.addEventListener('DOMContentLoaded', () => {

  // Get all "navbar-burger" elements
  const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

  // Check if there are any navbar burgers
  if ($navbarBurgers.length > 0) {

    // Add a click event on each of them
    $navbarBurgers.forEach( el => {
      el.addEventListener('click', () => {

        // Get the target from the "data-target" attribute
        const target = el.dataset.target;
        const $target = document.getElementById(target);

        // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
        el.classList.toggle('is-active');
        $target.classList.toggle('is-active');

      });
    });
  }

   // Get all "dropdownlink" elements
  const $mobdropdowns = Array.prototype.slice.call(document.querySelectorAll('.mobclick a'), 0);

  // Check if there are any navbar burgers
  if ($mobdropdowns.length > 0) {

    // Add a click event on each of them
    $mobdropdowns.forEach( el => {
      el.addEventListener('click', (e) => {

        

        console.log('click');

        let siblinkdrop = el.nextElementSibling;
        if (siblinkdrop) {
          e.preventDefault();
          siblinkdrop.classList.toggle('is-active');
        }
        


        // Get the target from the "data-target" attribute
        // const target = el.dataset.target;
        // const $target = document.getElementById(target);

        // // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
        // el.classList.toggle('is-active');
        // $target.classList.toggle('is-active');

      });
    });
  }

  const $expandlinks = Array.prototype.slice.call(document.querySelectorAll('.expandlink'), 0);
  if ($expandlinks.length > 0) {
      $('.expandlink').click(function (event) {
        $(this).parent().next('div.expandercnt').slideToggle(200, function () {
          //
        });

        return false;
      });
  }

  const $searchform = Array.prototype.slice.call(document.querySelectorAll('.searchformwrapper'), 0);
  if ($searchform.length > 0) {
    $(".searchbtn").click(function() {
      if (jQuery("#searchformwrapper .searchfield").is(":visible")) {
        $("#searchformwrapper").css({
          width: "38px",
        });
        $("#searchformwrapper .searchfield").hide();
      } else {
        $("#searchformwrapper").css({
          width: "290px",
        });
        $("#searchformwrapper .searchfield").fadeIn("fast");
      }
    });
  }

  window.onscroll = function() {reduceHeader()};

  function reduceHeader() {
    if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
      if (document.getElementById('nbalogo') !=null) {
        document.getElementById('nbalogo').className = 'collapse';
      }
      if (document.getElementById('nbalogosec') !=null) {
        document.getElementById('nbalogosec').className = 'collapse';
      }
      if (document.getElementById('navbarouter') !=null) {
        document.getElementById('navbarouter').className = 'navbarouter nothome collapse';
      }
      if (document.getElementById('navbarouterhome') !=null) {
        document.getElementById('navbarouterhome').className = 'navbarouter home collapse';
      }
      if (document.getElementById('headcontainer') !=null) {
        document.getElementById('headcontainer').className = 'container collapse';
      }
      if (document.getElementById('rangepicker') !=null) {
         document.getElementById('rangepicker').className = 'rangepicker collapse';
      }
      if (document.getElementById('menu-main-menu') !=null) {
         document.getElementById('menu-main-menu').className = 'navbar-end collapse';
      }
    } else {
      if (document.getElementById('nbalogo') !=null) {
        document.getElementById('nbalogo').className = '';
      }
      if (document.getElementById('nbalogosec') !=null) {
        document.getElementById('nbalogosec').className = '';
      }
      if (document.getElementById('navbarouter') !=null) {
        document.getElementById('navbarouter').className = 'navbarouter nothome';
      }
      if (document.getElementById('navbarouterhome') !=null) {
        document.getElementById('navbarouterhome').className = 'navbarouter home';
      }
      if (document.getElementById('headcontainer') !=null) {
        document.getElementById('headcontainer').className = 'container';
      }
      if (document.getElementById('rangepicker') !=null) {
        document.getElementById('rangepicker').className = 'rangepicker';
      }
      if (document.getElementById('menu-main-menu') !=null) {
        document.getElementById('menu-main-menu').className = 'navbar-end';
      }
    }
  }

  const homegliderExists = document.querySelector('.homesliders');
  if (homegliderExists) {

    window.addEventListener('load', function () {
      var glide = new Glide('#options-autoplay', {
          type: 'carousel',
          autoplay: false,
          hoverpause: 1,
          gap: 0,
          startAt: 0,
          perView: 1,
        })

        glide.mount()
    }); 

  }

  const dateTextExists = document.getElementById("dateTest1");
  if (dateTextExists) {
    var selector = document.getElementById("dateTest1");
    var im = new Inputmask('datetime', {
          inputFormat: 'mm/dd/yyyy',
          placeholder: 'MM/DD/YYYY'
        });
    im.mask(selector);

    $('.checkyouth1').click(function (e) { 
			e.preventDefault();
			
			var dateinputstr = $('#dateTest1').val();
			var dateinput = new Date(dateinputstr);
			var datenow = Date.now();
			var diff = getYears(datenow, dateinput);
			if (diff > 21 || isNaN(diff)) {
				alert('Sorry, this membership is for users 21 or younger.');
				return false;
			} else {
				var href = $(this).attr('href');
				window.location.href = href;
				return true;
			}
			
		});
  }

  	$('.expandlinktwo').click(function (event) {

      $(this).next('div.expandercnt').slideToggle(200, function () {

        if ($(".equalizer")[0]) {
          Foundation.reInit('equalizer');
        }
      });

      return false;
    });

});

let pedigreebtn = document.querySelector(".viewpedigree");
let pedigreewrap = document.querySelector(".pedigreewrap");
if (pedigreewrap) {
  pedigreebtn.onclick = function (e) {
    e.preventDefault();
    pedigreewrap.classList.toggle("show");
  };
}


function getYears(date1, date2) {
  	var years = new Date(date1).getFullYear() - new Date(date2).getFullYear();
    var month = new Date(date1).getMonth() - new Date(date2).getMonth();
    var dateDiff = new Date(date1).getDay() - new Date(date2).getDay();
    if (dateDiff < 0) {
      month -= 1;
    }
    if (month < 0) {
      years -= 1;
    }
    return years;
}

$('.downloadlinkover').click(function (e) { 
  e.preventDefault();
  var btnelid = this.id;
  var elid = btnelid.substr(8);
  $('#modal_' + elid).addClass('is-active');
});

$('.disclaimerbtn').click(function (e) { 
  e.preventDefault();
  var btnelid = this.id;
  var elid = btnelid.substr(4);
  var checkstate = $( '.agreecheck' ).is(':checked');
  if (checkstate===false) {
    $('.disclaimererror').show();
  } else {
    $('.disclaimererror').hide();
    $(".agreecheck"). prop("checked", false);
    $('#modal_' + elid).removeClass('is-active');
    $('#overlay_'+elid).hide();
    $('#link_'+elid).show();
  }

  // console.log('here');

  console.log(elid);
});

$('.modal-background').click(function (e) { 
  e.preventDefault();
  var elparent = $(this).parent().attr('id');
  var elid = elparent.substr(6);
  $('#modal_' + elid).removeClass('is-active');
});

$('.modal-close').click(function (e) { 
  e.preventDefault();
  var elparent = $(this).parent().attr('id');
  var elid = elparent.substr(6);
  $('#modal_' + elid).removeClass('is-active');
});

// $('.mobclick').click(function (e) { 
//   e.preventDefault();
//   console.log('click');
  
// });


document.addEventListener("DOMContentLoaded", updateRepeatCountFields );
jQuery(document).on('frmAfterAddRow', updateRepeatCountFields );
jQuery(document).on('frmAfterRemoveRow', updateRepeatCountFields );

function updateRepeatCountFields() {
var countFields = document.querySelectorAll( '.frm_repeat_640');
    let totalcount = 0;
    let attendeelistitems = [];

    for ( var i = 0, len=countFields.length; i<len; i++ ) {
        let repel = countFields[i];
        let inputElements = repel.querySelectorAll("input");

        

        if (inputElements[2].value != '') {
          attendeelistitems.push(inputElements[2].value)
        }
        countFields[i].value = i+1;
        totalcount = i;

       
    }

    if (totalcount > 0) {
      let attendeelist = document.querySelector(".attendeelist");

      let attendeeStr = '<h3 style="color: #005bcc;">You have added ' + totalcount + ' attendee(s):</h3><ul>';

      for (let index = 0; index < attendeelistitems.length; index++) {
        attendeeStr = attendeeStr + '<li style="font-size: 20px; font-weight: bold;">' + attendeelistitems[index] + '</li>';
      }

      attendeeStr = attendeeStr + '</ul>';

      attendeelist.innerHTML = attendeeStr;
   }

   // console.log(countFields.length);
    
}


// WEBPACK FOOTER //
// ./scripts/main.js